export enum EmailTemplateStatus {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT',
}

export enum EmailTemplateType {
    AUTOMATED = 'AUTOMATED',
    MANUAL = 'MANUAL',
}

export interface IEmailTemplate {
    id: number;
    email_category: string;
    language: number;
    template_type: EmailTemplateType;
    status: EmailTemplateStatus;
    name: string;
    name_editable: boolean;
    subject: string;
    body: string;
    parent_template: number | null;
    draft_id: number | null;
    last_edited_by_display: string;
    updated_at: string;
}

export interface IEmailTemplateListResponse {
    total_count: number;
    total_pages: number;
    current_page: number;
    next: string | null;
    previous: string | null;
    results: IEmailTemplate[];
}

export interface IEmailTemplatesFilters {
    status: EmailTemplateStatus | null;
    type: EmailTemplateType | null;
}

export interface IFetchEmailTemplatesParams {
    page: number;
    page_size: number;
    search?: string;
    template_type?: EmailTemplateType;
    status?: EmailTemplateStatus;
}

export interface IEmailTemplateLabel {
    label: string;
    value: string;
}

export interface IPreviewTemplatePayload {
    jobApplicationId: number;
    emailTemplateId: number;
}

export interface IPreviewTemplateResponse {
    subject: string;
    body: string;
}

export interface ICreateEmailTemplatePayload {
    email_category?: string;
    name?: string;
    language: number;
    subject: string;
    body: string;
}

export interface IUpdateEmailTemplatePayload {
    id: number;
    name?: string;
    subject?: string;
    body?: string;
}
